module.exports = __webpack_public_path__ + "static/grafika5@2x-db5048aa21eceabd41d96e6806972e3b.png";